import { makeReverseTComposable } from "@saflib/vue";
import { powerUpSdkStrings } from "./strings.ts";

export const { useReverseT } = makeReverseTComposable(powerUpSdkStrings);
